import { store } from './store'

export { actions } from './store'

export default store
